import Vue from 'vue'

Vue.component('field-text', require('./components/Fields/Text').default);
Vue.component('field-file', require('./components/Fields/File').default);
Vue.component('field-input', require('./components/Fields/Input').default);
Vue.component('field-phone', require('./components/Fields/Phone').default);
Vue.component('field-radio', require('./components/Fields/Radio').default);
Vue.component('field-editor', require('./components/Fields/Editor').default);
Vue.component('field-select', require('./components/Fields/Select').default);
Vue.component('field-switch', require('./components/Fields/Switch').default);
Vue.component('field-toggle', require('./components/Fields/Toggle').default);
Vue.component('field-datetime', require('./components/Fields/Datetime').default);
Vue.component('field-timezone', require('./components/Fields/Timezone').default);
Vue.component('field-checkbox', require('./components/Fields/Checkbox').default);
Vue.component('field-file-model', require('./components/Fields/FileModel').default);
Vue.component('field-state-counties', require('./components/Fields/StateCounties').default);
Vue.component('tinymce-editor', require('@tinymce/tinymce-vue').default);